export const mutations = {
  addAttributsExclure(state, attributsexclure) {
    state.attributsexclure = attributsexclure;
  },
  setAttributsExclure(state, attributsexclure) {
    state.attributsexclure = attributsexclure;
  },
  addAttributsExclures(state, attributsexclure) {
    state.attributsexclures = attributsexclure;
  },
  addAttributsExcluresPage(state, attributsexclure) {
    state.attributsexclures = [...attributsexclure.content];
    console.log(attributsexclure.content);
    state.pagination = {
      pageable: attributsexclure.pageable,
      totalElements: attributsexclure.totalElements,
      totalPages: attributsexclure.totalPages,
    };
  },
};
